import config from "config/config"
import i18n from "intl/i18n"
import { Guid, ITranslations } from "@/types"

export interface IGetColorDto {
    id: Guid
    code: string
    translations: ITranslations
}

export interface ICreateUpdateColorDto {
    code: string
    translations: ITranslations
}

export default class Color {
    id: Guid
    code: string
    translations: ITranslations

    constructor(dto: IGetColorDto) {
        this.id = dto.id
        this.code = dto.code
        this.translations = dto.translations
    }

    get name() {
        return this.translations[i18n.language
            || config.defaultLanguage]
            || this.translations[config.defaultLanguage]
            || ""
    }
}
